import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { postControlGroup } from '../Api'

export default generateApiAction({
  baseType: Types.CTRL_GROUPS.POST,
  api: postControlGroup,
  responseType: RESPONSETYPE.ID
})



// WEBPACK FOOTER //
// ./src/actions/controlGroups/PostAction.js